import React from 'react';
import { PartnerForm } from '../features/b2b';

const B2BPartnerFormPage = () => {
  return <PartnerForm />;
};

export default B2BPartnerFormPage;
